import api from "../../../api.js";

// Fetch pending packaged (non-chronic) script cards
export async function fetchPendingPackagedCards({ search = "", date = "", branchcode } = {}) {
  try {
    const res = await api.get("/dispensary/package-script/pending", {
      params: {
        ...(search ? { search } : {}),
        ...(date ? { date } : {}),
        ...(branchcode ? { branchcode } : {}),
      },
    });
    return res.data?.data || [];
  } catch (e) {
    console.warn("fetchPendingPackagedCards failed", e);
    return [];
  }
}

